<template>
	<div class="jiangli">
		<div class="jiangli_top">
			<img @click="fanhui()" src="../../assets/images/licai/fanhui.png"/>
			<p class="">安全保障</p>
		</div>
		<div class="jiangli_con">
			<div class="jiangli_con_cnt">
				<h4>平台规范 • 多重规范机制</h4>
				
				 <p class="">富达集团自成立以来，只与国内排名优质的金融类/金融机构进行对接，并在合作前进行360度严格禁调，合作中实行动态管理，进行持续有效的风险监控，从源头上隔离风险。</p>
				
				<h4>保障投资人</h4>
				
				<p class="">投资人在充值和提现前必须实名认证、手机绑定等多重安全认证，任何帐户资金的提现，只能转出到本人实名绑定的银行，账户完全保障投资人的资金转出安全。</p>
				<h4> 专人操作、复核</h4>
				 
			    <p class=""> 内部严格的资金管理流程和完善安全的系统。所有资金操作都将通过“专人操作、专人复核”的程序完成。</p>
				<h4>低风险、高收益</h4>
				 
				<p class=""> 平台为确保合作机构提供给投资者的项目低风险，高收益，将从组织架构上系统的、科学的为投资者进行项目筛选和风险保障，为项目风险整体把控并在需要时代表投资者进行权益维护与法律保障。</p>
				<h4> 本金收益按时回收</h4>
				 
				<p class=""> 平台发布的每一个产品均有（保险公司承保）提供全额无限连带担保，保证了投资人的本金和收益按时回收。</p>
				<h4> 数据加密保护技术</h4>
				 
				<p class=""> 采用SSL256位数据传输加密保护技术，让客户在进行个人账户管理、充值等涉及敏感信息的操作时，信息自动加密，确保信息的安全传输。所有资金操作都将通过“专人操作、专人复核”的程序完成。</p>
				
				
				
				<h4>强大的资金监管</h4>
				
				<p class="">第三方支付、投资者的沉淀资金均有银监会在线监管管理，保证客户资金安全。</p>
				
				<h4>全程动态监测</h4>
				
				<p class="">专业的风险管理团队，将对投资标的实施全程动态监测。我们秉持先进理念，凭借专业的生态风控系统，为广大用户构建了一个安全放心的金融交易信息服务平台，保证产品安全。</p>
				
				<h4>隐私安全--为您保驾护航--机密保障</h4>
				
				<p class="">开展业务是建立在与客户彼此信任的基础之上的，为了提供更好的客户服务和产品，确保投资人提供的所有信息都能得到机密保障，我们采用关于信息保护的政策。</p>
				
				<h4>效率与质量</h4>
				
				<p class="">收集信息的范围仅限于那些本公司认为对了解您的财务需求和开展业务所必需的相关资料,只在提高提供服务的效率与质量。</p>
				
				<h4>严格安全系统</h4>
				<p class="">将对客户提供的信息严格保密，设有严格的安全系统,以防止未经授权的任何人包括本公司的职员获取客户信息。</p>
				
				<h4>保密责任</h4>
				
				<p class="">因服务必要而委托的第三方，在得到本公司许可获取客户的个人信息时都被要求严格遵守保密责任。</p>
				
				<h4>资金安全--实现真正第三方独立互管</h4>
				
				<p class="">严守平台技术。用户资金只存在于第三方支付的互管账户里，与平台有效隔离，保证安全。 在将投资者资金融投之前，还会对项目进行风险评估审核，验证，从而更确保了每一个项目的合理和稳健，保证了投资者的资金流向安全。</p>
				
				<h4>法律安全保障--保证投资收益合法有效</h4>
				
				<p class="">平台上所有投资项目设立、审核及开放认购均通过专业法律团队审核法律文本，确保投资人在平台上的投资收益合法有效。作为互联网在创新发展的同时，坚守政策法规。在具有极强公信力的机构严格监管下，充分发挥互联网的优势，致力于"零"风险模式运作。</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "jiangli",
		data: function() {
			return {
				types:0,
			};
		},
		created() {
	
		},
		mounted: function() {
			
		},
		methods: {
			fanhui:function(){
				this.$router.push({
					path:'/'
				})
			}
		},
	};
</script>
<style>
	h4{
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		line-height: 43px;
		opacity: 0.99;
	}
	.jiangli_con_cnt p{
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		line-height: 28px;
		opacity: 0.99;
	}
	.jiangli_con{padding: 30px 15px;}
	.jiangli_top{
		width: 100%;
		height: 45px;
		line-height: 45px;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.jiangli_top img{
		height: 30px;
		width: 30px;
		position: absolute;left: 0px;
	}
	.jiangli_top p{
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		text-align: center;
	}
</style>
